module.exports = __webpack_public_path__ + "static/media/countBedrooms.b7067365.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/generalInformation/countBedrooms.svg
// module id = 305
// module chunks = 0